import type { StaticLayerPayload } from "@config";
import { SimpleLibrary } from "@library-combos/simple";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: SimpleLibrary,
};

export const Simple = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
